export const suppliersManagementEnabled = (company) => company?.suppliers_management_enabled && company?.type === 'HQ';

export const offerCatalogEnabled = (company) => company?.offer_catalog_enabled;

export const ordersApprovalEnabled = (company) => company?.is_order_approval_enabled;
